import React from 'react'

import { Card } from '@/components/cards/Card'
import { EChart } from '@/components/charts/EChart'

import { EmptyHint, ErrorHint } from '../drawers/entityDrawer.helpers'

// Drawer chart card with a unified loading / error / empty / data
// ladder. Pass `disabled` (e.g. "no sid available") to short-circuit
// to the empty state without firing a fetch.
//
// `emptyMessage` may be a string or a node; the latter lets callers
// inject extra context (e.g. "...try clearing the X filter").
//
// `footer` rides under the chart in the data state only -- it's for
// affordances derived from the plotted rows (drill-out links), which
// have nothing to point at while loading, erroring or empty.
export const ChartCard = ({
  title,
  option,
  height = 240,
  loading,
  error,
  isEmpty,
  disabled = false,
  disabledMessage,
  errorMessage = 'Couldn’t load this chart.',
  emptyMessage = 'No data in the current window.',
  events,
  footer,
}) => {
  let body
  if (disabled) {
    body = <EmptyHint>{disabledMessage || emptyMessage}</EmptyHint>
  } else if (loading) {
    body = <EChart option={option} loading style={{ height: `${height}px` }} />
  } else if (error) {
    body = <ErrorHint>{errorMessage}</ErrorHint>
  } else if (isEmpty) {
    body = <EmptyHint>{emptyMessage}</EmptyHint>
  } else {
    body = (
      <>
        <EChart option={option} events={events} style={{ height: `${height}px` }} />
        {footer}
      </>
    )
  }
  return <Card title={title}>{body}</Card>
}
